module.exports = __webpack_public_path__ + "static/media/success.a80a402c.svg";